import * as React from "react";
import { Modal, Button } from "semantic-ui-react";
import { IsLoadingButton } from "@teamprevent/common/IsLoadingButton";

import { SAVE_EMPLOYEERECORD } from "../actiontypes";

export const ConfirmTerminationDateChangeModal: React.FunctionComponent<{ open: boolean; submit: () => void; close: () => void }> = (props) => {
    return (
        <Modal
            open={props.open}
        >
            <Modal.Content>
                        Setting a termination date for this employee will cause their account to be deactivated on this date.
                        All of their cases, associated tasks and appointments will be cancelled on this date.
                        Are you sure you want to do this?
            </Modal.Content>
            <Modal.Actions>
                <IsLoadingButton content="Yes" negative onClick={props.submit} requestNames={SAVE_EMPLOYEERECORD} />
                <Button content="No" onClick={props.close} />
            </Modal.Actions>
        </Modal>
    );
};
